import { APIGet, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ITournament } from "redux/reducers/models/tournament";

const apiVersion = "2024-04";
const adminType = "guest";
const baseTournamentUrl = "/" + apiVersion + "/" + adminType + "/tournament";

interface IGetTournament {
  id?: number;
  facility_id?: number;
  handle?: string;
  year?: number;
  month?: number;
  timeframe?: "upcoming" | "past";
  offset?: number;
  limit?: number;
  search?: string;
}

export async function GetGuestTournament(
  params: IGetTournament,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ITournament>>> {
  return await APIGet(baseTournamentUrl, params, useGlobalLoader, token);
}

export interface IGuestSponsorship {
  id: number;
  source: string;
}

export async function GetGuestTournamentSponsorship(
  params: { tournament_id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<IGuestSponsorship[]>> {
  return await APIGet(baseTournamentUrl + "/sponsorship", params, useGlobalLoader, token);
}

export async function GetGuestOnlineStoreTournaments(
  params: Pick<IGetTournament, "id" | "facility_id" | "handle">,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ITournament>>> {
  return await APIGet(baseTournamentUrl + "/online-store", params, useGlobalLoader, token);
}
